import React, { useState, useCallback, useEffect } from 'react';
import lodash from 'lodash';
import {useList} from 'react-use';

import './style.scss';
import DragableList from './DragableList';
import useDisableScrollDocument from '../../../useHook/useDisableScrollDocument'

function SwapItemModal(props) {
    useDisableScrollDocument();

    const [leftColumns, leftColumnsHelper] = useList([]);
    const [rightColumns, rightColumnsHelper] = useList([]);
    const [selectedLeft, setSelectedLeft] = useState(null);
    const [selectedRight, setSelectedRight] = useState(null);

    useEffect(() => {
        rightColumnsHelper.set(props.rightColumns);
        const notSelected = lodash.differenceWith(props.leftColumns, props.rightColumns, lodash.isEqual);
        leftColumnsHelper.set(notSelected);
    }, []);

    const onAddToLeft = useCallback(() => {
        if(!selectedRight) return;

        const rightIndex = lodash.findIndex(rightColumns, (item) => item.column === selectedRight.column);

        rightColumnsHelper.removeAt(rightIndex);
        leftColumnsHelper.push(selectedRight);
        setSelectedRight(null);

    }, [rightColumns, selectedRight]);

    const onAddToRight = useCallback(() => {
        if(!selectedLeft) return;
        const leftIndex = lodash.findIndex(leftColumns, (item) => item.column === selectedLeft.column);
        leftColumnsHelper.removeAt(leftIndex);
        rightColumnsHelper.push(selectedLeft);
        setSelectedLeft(null);
    }, [leftColumns, selectedLeft]);

    return (
        <div className="wrap-item-select">
            <div className="item-select">
                <h4>項目カスタマイズ</h4>
                <div>
                    <DragableList
                        list={leftColumns}
                        selectedItem={selectedLeft}
                        setList={(items) => leftColumnsHelper.set(items)}
                        setSelectedItem={(item) => setSelectedLeft(item)}
                    />
                    <div>
                        <div onClick={onAddToLeft}>
                            <img src="/img/navigation/arrow_back_24px.svg" alt="arrow-left" />
                        </div>
                        <div onClick={onAddToRight}>
                            <img src="/img/ic_arrow_right.svg" alt="arrow-right" />
                        </div>
                    </div>
                    <DragableList
                        list={rightColumns}
                        selectedItem={selectedRight}
                        setList={(items) => rightColumnsHelper.set(items)}
                        setSelectedItem={(item) => setSelectedRight(item)}
                    />
                </div>
                <p>項目の表示順はドラッグ&ドロップで変更することができます</p>
                <div>
                    <button onClick={() => props.onCloseModal()}>キャンセル</button>
                    <button onClick={() => props.onConfirm(rightColumns)}>更新</button>
                </div>
            </div>
        </div>
    )
}

export default SwapItemModal;
